export default "__VITE_ASSET__BT8TIjMu__"